import { Phone } from "lucide-react";

export default function MobileStickyBar() {
  return (
    <div className="sticky-call-bar" data-testid="mobile-sticky-bar">
      <a 
        href="tel:+18884451244" 
        className="flex items-center justify-center gap-3 font-bold text-lg"
      >
        <Phone className="w-5 h-5 animate-pulse-slow" />
        <span>CALL NOW: 888-445-1244</span>
      </a>
    </div>
  );
}
